import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'
import { getDate } from '../../../features/presupuestador/NavBudgetList'
import qs from 'query-string'
import { QS_CONFIG_ARRAY_ENCODED } from '../../../features/common/Utilities'

export async function getLeads({ search }) {
  const query = qs.parse(search, QS_CONFIG_ARRAY_ENCODED)

  let openBracketEncode = "%5B"
  let closeBracketEncode = "%5D"
  let equalEncode = "%3D"
  let ampersandEncode = '%26'

  const replaceUnnecessaryEncoded = (oldQuery) => {
    return oldQuery.replaceAll(ampersandEncode, '&').replaceAll(`${openBracketEncode}${closeBracketEncode}${equalEncode}`, "[]=")
  }

  const objectQueryDate = {
    'Hoy':'hoy', 
    'Ayer':'ayer', 
    'Últimos 7 días':'7dias', 
    'Últimos 30 días':'30dias', 
    'Mes actual': 'este-mes',
    'Mes pasado':'mes-pasado'
  }
  
  let dateSelected = query.query_date
  
  if(dateSelected) {
      let days 
      if (Array.isArray(dateSelected)){
        if(dateSelected.length > 1){
          days = dateSelected
        }
        else{
          dateSelected = dateSelected[0]
          days = getDate(objectQueryDate[dateSelected])
        } 
      }
      else days = getDate(objectQueryDate[dateSelected])
      delete query.query_date
      query.desde = days[0]
      query.hasta = days[1]
  }

  let queryEncoded = `${LEADS_ENDPOINT}/?${qs.stringify(query, QS_CONFIG_ARRAY_ENCODED)}`
  queryEncoded = replaceUnnecessaryEncoded(queryEncoded) 
  try{
    const data = await axios.get(`${queryEncoded}`, {
      timeout: 180000, // 3 minutos
    })
    return data.data;
  }catch(error){
      throw new Error(error)
  }
}
